module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAYAAAD/Rn+7AAAAx0lEQVR42u3RzQqCQBSGYW+p1glBqJFKWpCCYKQEteu/lkHRHXQxLbqmSsxRi750odtcBDOLGXgXc87mgSO8xfq9SqD0ciDy0kYNRJMQjxyQiY9Ek/HKZsWeKrCIrGYg03GWh3gzz2fsAG+nA567JR7eEKHvIlwvEBz37AAjy0Bg6ghUGYHcQqo0kRodtk4c9zNgT0VitBHbJlsnjlwbSVcpQYkuIXSs8v+5XmhUAJmNAzmQA/8GHGxFGlUHCucWjTiQAznwV1+mhFlDAO6IpAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/om.png
// module id = 904
// module chunks = 0